/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* global queryString, isMinors, trendingPlayers */
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { csv } from 'd3-fetch'
import async from 'async'
/* Material UI Components */
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Slider from '@material-ui/core/Slider'
import {
    makeStyles,
    StylesProvider,
    createGenerateClassName,
} from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers'

import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns'

import throttle from 'lodash/throttle'
import filter from 'lodash/filter'
import isEqual from 'lodash/isEqual'
import includes from 'lodash/includes'
import uniqBy from 'lodash/uniqBy'
import sortBy from 'lodash/sortBy'

import { appSettings } from 'bam-node-baseball-savant/leaderboard/appSettings'

import events from 'bam-node-evp/src/Utilities/EventTypes'
import teamsById from 'bam-node-evp/src/Utilities/Teams'
import venues from 'bam-node-evp/src/Utilities/Venues'
import runCalculations from 'bam-node-evp/src/Utilities/RunCalculations'

// Use for calculations
import SavantModel from 'bam-node-evp/src/Models/SavantModel'
import find from 'lodash/find'
import LoadSchema from './Schema'

import MultiPick from './UI/MultiPick'
import App from './App'
import SaveImage from './Download/index'

const { currentYear, years: defaultYears } = appSettings.illustrator

const yearMin = defaultYears.at(-1)

const venueNamesDict = venues.venues.reduce((acc, curr) => {
    acc[curr.value] = curr.name
    return acc
}, {})

const generateClassName = createGenerateClassName({
    productionPrefix: 'c',
    seed: 'App1',
})

/* Material UI Slider Functions */
function sliderValueText(value) {
    return `${value} MPH`
}

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        backgroundColor: '#fff',
    },
    tabRoot: {
        minWidth: 100,
    },
}))

/* const acStyles = makeStyles((theme) => ({
    inputRoot: {
        borderRadius: "0px",
        padding: "0px",
        margin: "0px",
        height: "3rem",
        fontFamily: "Roboto Condensed",
    },
    label: {
        fontFamily: "Roboto Condensed",
    },
})); */
const acStyles = makeStyles(() => ({
    label: {
        transform: 'translate(1rem, 1rem) scale(1)',
        fontFamily: 'Roboto Condensed',
        paddingTop: '0rem',
    },

    focus: {
        color: '#3a9098 !important',
    },
    /* Styles applied when the popup icon is rendered. */
    inputRoot: {
        borderRadius: '0px',
        padding: '0px',
        margin: '0px',
        height: '3rem',
    },
    cssLabel: {
        color: '#3a9098',
    },

    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderColor: `#3a9098 !important`,
        },
    },

    cssFocused: {},

    notchedOutline: {
        borderWidth: '1px',
        borderColor: '#3a9098 !important',
    },
}))

function Data(props) {
    const classes = useStyles()
    const autoCompleteStyles = acStyles()

    const [tabSelection, setTabSelection] = useState(0)
    const [pageWidth, setPageWidth] = useState(window.innerWidth || 1000)

    const [modalOpen, setModalOpen] = useState(false)
    const [togglePlayerStats, setTogglePlayerStats] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [options, setOptions] = useState(trendingPlayers || [])
    const [playerInfo, setPlayerInfo] = useState(null)
    const [player, setPlayer] = React.useState(
        // eslint-disable-next-line react/destructuring-assignment
        props.player || {
            playerType: 'pitcher',
            playerName: null,
            playerId: null,
        }
    )
    const [otherPlayerType, setOtherPlayerType] = useState('pitcher')

    const [subTitle, setSubTitle] = useState(queryString.subTitle || '')

    const [chartType, setChartType] = useState(
        queryString.chartType || 'zoneChart-totalPitches'
    )

    const [chartName, setChartName] = useState(
        queryString.chartName || 'Zone - Total Pitches'
    )
    const [venueId, setVenueId] = useState(queryString.venue || 7)
    const [venueName, setVenueName] = useState(
        venueNamesDict[venueId] || 'Kauffman Stadium'
    )

    const [saveImageText, setSaveImageText] = useState('Save Image')
    const [isSavingImage, setIsSavingImage] = useState(false)
    const [embedImageText, setEmbedImageText] = useState('Embed Image')
    const [embedLink, setEmbedLink] = useState(null)
    const [isDataLoading, setIsDataLoading] = useState(false)
    const [isYearlyDataLoading, setIsYearlyDataLoading] = useState(false)
    const [pageLoad, setPageLoad] = useState(false)
    const [tweakVisual, setTweakVisual] = useState(false)
    const handleClose = () => {
        // setOpen(false)
    }

    // Data Filters
    const [shape, setShape] = useState(queryString.shape || 'square')
    const [shapeName, setShapeName] = useState(
        queryString.shapeName || 'Square (Instagram)'
    )
    const [perspective, setPerspective] = useState(
        queryString.perspective || 'catcher'
    )

    const [pitcherThrows, setPitcherThrows] = useState(
        queryString.pitcherThrows || ''
    )
    const [batterStands, setBatterStands] = useState(
        queryString.batterStands || ''
    )

    const [years, setYears] = useState(
        queryString.years ? JSON.parse(queryString.years) : [currentYear]
    )

    const [plateAppearanceResults, setPlateAppearanceResults] = useState(
        queryString.plateAppearanceResults
            ? JSON.parse(queryString.plateAppearanceResults)
            : []
    )
    const [seasonType, setSeasonType] = useState(
        queryString.seasonType ? JSON.parse(queryString.seasonType) : ['R']
    )
    const [pitchTypes, setPitchTypes] = useState(
        queryString.pitchTypes ? JSON.parse(queryString.pitchTypes) : []
    )
    const [pitchResults, setPitchResults] = useState(
        queryString.pitchResults ? JSON.parse(queryString.pitchResults) : []
    )
    const [facingPlayer, setFacingPlayer] = useState(
        queryString.facingPlayer ? JSON.parse(queryString.facingPlayer) : []
    )

    const [balls, setBalls] = useState(
        queryString.balls ? JSON.parse(queryString.balls) : []
    )
    const [strikes, setStrikes] = useState(
        queryString.strikes ? JSON.parse(queryString.strikes) : []
    )
    const [outs, setOuts] = useState(
        queryString.outs ? JSON.parse(queryString.outs) : []
    )
    const [battedBallType, setBattedBallType] = useState(
        queryString.battedBallType ? JSON.parse(queryString.battedBallType) : []
    )

    const [selectedGames, setSelectedGames] = useState(
        queryString.selectedGames ? JSON.parse(queryString.selectedGames) : []
    )
    const [gameDateGT, setGameDateGT] = useState(null)
    const [gameDateLT, setGameDateLT] = useState(null)
    const [exitVelocityGT, setExitVelocityGT] = useState(
        queryString.exitVelocityGT ? Number(queryString.exitVelocityGT) : 0
    )
    const [exitVelocityLT, setExitVelocityLT] = useState(
        queryString.exitVelocityLT ? Number(queryString.exitVelocityLT) : 125
    )
    const [launchAngleGT, setLaunchAngleGT] = useState(
        queryString.launchAngleGT ? Number(queryString.launchAngleGT) : -90
    )
    const [launchAngleLT, setLaunchAngleLT] = useState(
        queryString.launchAngleLT ? Number(queryString.launchAngleLT) : 90
    )

    const [pitchVelocityGT, setPitchVelocityGT] = useState(
        queryString.pitchVelocityGT ? Number(queryString.pitchVelocityGT) : 0
    )
    const [pitchVelocityLT, setPitchVelocityLT] = useState(
        queryString.pitchVelocityLT ? Number(queryString.pitchVelocityLT) : 105
    )

    const [homeTeam, setHomeTeam] = useState(
        queryString.homeTeam ? JSON.parse(queryString.homeTeam) : []
    )
    const [awayTeam, setAwayTeam] = useState(
        queryString.awayTeam ? JSON.parse(queryString.awayTeam) : []
    )
    const [vsTeam, setVsTeam] = useState(
        queryString.vsTeam ? JSON.parse(queryString.vsTeam) : []
    )

    const [updateId, setUpdateId] = useState(0)

    function populateUrl(playerType = null) {
        let pType = playerInfo.playerType
        let selectedYears = JSON.stringify(years)
        if (playerType) {
            selectedYears = ''
            pType = playerType
        }
        const playerUrl = `?playerId=${playerInfo.playerId}&playerType=${pType}&name=${playerInfo.name}`

        const stateUrl = `&tabSelection=${tabSelection}&shape=${shape}&shapeName=${shapeName}&subTitle=${subTitle}&chartType=${chartType}&chartName=${chartName}&pitcherThrows=${pitcherThrows}&batterStands=${batterStands}&plateAppearanceResults=${JSON.stringify(
            plateAppearanceResults
        )}&pitchTypes=${JSON.stringify(pitchTypes)}&seasonType=${JSON.stringify(
            seasonType
        )}&pitchResults=${JSON.stringify(
            pitchResults
        )}&facingPlayer=${JSON.stringify(facingPlayer)}&balls=${JSON.stringify(
            balls
        )}&battedBallType=${JSON.stringify(
            battedBallType
        )}&years=${selectedYears}&strikes=${JSON.stringify(
            strikes
        )}&outs=${JSON.stringify(outs)}&selectedGames=${JSON.stringify(
            selectedGames
        )}&homeTeam=${JSON.stringify(homeTeam)}&awayTeam=${JSON.stringify(
            awayTeam
        )}&vsTeam=${JSON.stringify(
            vsTeam
        )}&exitVelocityGT=${exitVelocityGT}&exitVelocityLT=${exitVelocityLT}&pitchVelocityGT=${pitchVelocityGT}&pitchVelocityLT=${pitchVelocityLT}&launchAngleGT=${launchAngleGT}&launchAngleLT=${launchAngleLT}&perspective=${perspective}&venue=${venueId}`
        window.history.pushState('', '', playerUrl + stateUrl)
        return playerUrl + stateUrl
    }

    function resetStateFormValues() {
        setPitcherThrows('')
        setBatterStands('')
        setSeasonType(['R'])
        setPlateAppearanceResults([])
        setPitchTypes([])
        setPitchResults([])
        setFacingPlayer([])
        setBalls([])
        setStrikes([])
        // setYears([]);
        setOuts([])
        setBattedBallType([])
        setSelectedGames([])
        setGameDateGT(null)
        setGameDateLT(null)
        setExitVelocityGT(0)
        setExitVelocityLT(125)
        setLaunchAngleGT(-90)
        setLaunchAngleLT(90)
        setPitchVelocityGT(0)
        setPitchVelocityLT(105)
    }

    const [staticPlayerData, staticPlayerDataChanged] = useState(null)
    const [playerData, playerDataChanged] = useState(null)

    const [playerStats, playerStatsChanged] = useState(null)
    const previousDataState = usePrevious(playerData)

    const [uniqYears, setUniqYears] = useState([])
    const [uniqPitches, setUniqPitches] = useState([])
    const [uniqPlayers, setUniqPlayers] = useState([])
    const [uniqGames, setUniqGames] = useState([])

    function usePrevious(value) {
        const ref = useRef()
        useEffect(() => {
            ref.current = value
        })
        return ref.current
    }

    useEffect(() => {
        let tempData = staticPlayerData

        if (chartType === 'pitchChart-paResult') {
            tempData = filter(tempData, (d) => Number(d.is_lastpitch) === 1)
        }
        if (chartType === 'pitchChart-battedBallType') {
            tempData = filter(tempData, (d) => Number(d.is_hit_into_play) === 1)
        }

        if (pitcherThrows) {
            tempData = filter(tempData, (d) => d.p_throws === pitcherThrows)
        }
        if (batterStands) {
            tempData = filter(tempData, (d) => d.stand === batterStands)
        }
        if (plateAppearanceResults && plateAppearanceResults.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(plateAppearanceResults, d.events)
            )
        }
        if (seasonType && seasonType.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(seasonType, d.game_type)
            )
        }

        if (pitchResults && pitchResults.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(pitchResults, d.description)
            )
        }
        if (balls && balls.length > 0) {
            tempData = filter(tempData, (d) => includes(balls, String(d.balls)))
        }
        if (strikes && strikes.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(strikes, String(d.strikes))
            )
        }
        if (battedBallType && battedBallType.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(battedBallType, String(d.bb_type))
            )
        }

        if (years && years.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(years, Number(d.game_year))
            )
        }

        if (outs && outs.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(outs, String(d.outs_when_up))
            )
        }

        if (selectedGames && selectedGames.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(selectedGames, d.game_pk)
            )
        }

        if (pitchTypes && pitchTypes.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(pitchTypes, d.pitch_type)
            )
        }

        if (homeTeam && homeTeam.length > 0) {
            tempData = filter(tempData, (d) =>
                homeTeam?.includes(d.home_team_id)
            )
        }

        if (vsTeam && vsTeam.length > 0) {
            if (otherPlayerType === 'pitcher') {
                tempData = filter(tempData, (d) =>
                    vsTeam?.includes(d.fielding_team_id)
                )
            } else {
                tempData = filter(tempData, (d) =>
                    vsTeam?.includes(d.batting_team_id)
                )
            }
        }

        if (awayTeam && awayTeam.length > 0) {
            tempData = filter(tempData, (d) =>
                awayTeam?.includes(d.away_team_id)
            )
        }

        if (facingPlayer && facingPlayer.length > 0) {
            tempData = filter(tempData, (d) =>
                includes(facingPlayer, d[otherPlayerType])
            )
        }

        if (gameDateGT) {
            tempData = filter(tempData, (d) => d.game_date >= gameDateGT)
        }
        if (gameDateLT) {
            tempData = filter(tempData, (d) => d.game_date <= gameDateLT)
        }

        if (exitVelocityGT && exitVelocityGT > 0) {
            tempData = filter(
                tempData,
                (d) =>
                    Number(d.launch_speed) >= Number(exitVelocityGT) &&
                    Number(d.launch_speed) > 0 &&
                    Number(d.launch_speed) !== 0
            )
        }

        if (exitVelocityLT && exitVelocityLT <= 124) {
            tempData = filter(
                tempData,
                (d) =>
                    Number(d.launch_speed) <= Number(exitVelocityLT) &&
                    Number(d.launch_speed) > 0 &&
                    Number(d.launch_speed) !== 0
            )
        }

        if (launchAngleGT && launchAngleGT > -90) {
            tempData = filter(
                tempData,
                (d) =>
                    Number(d.launch_angle) >= Number(launchAngleGT) &&
                    Number(d.launch_angle) > -90 &&
                    Number(d.launch_angle) !== 0
            )
        }

        if (launchAngleLT && launchAngleLT < 90) {
            tempData = filter(
                tempData,
                (d) =>
                    Number(d.launch_angle) <= Number(launchAngleLT) &&
                    Number(d.launch_angle) > -90 &&
                    Number(d.launch_angle) !== 0
            )
        }

        if (pitchVelocityGT) {
            tempData = filter(
                tempData,
                (d) =>
                    Number(d.release_speed) >= Number(pitchVelocityGT) &&
                    Number(d.release_speed) > 0
            )
        }

        if (pitchVelocityLT && pitchVelocityLT < 105) {
            tempData = filter(
                tempData,
                (d) =>
                    Number(d.release_speed) <= Number(pitchVelocityLT) &&
                    Number(d.release_speed) > 0
            )
        }

        if (previousDataState && !isEqual(previousDataState, tempData)) {
            // setUniqValues(tempData);

            playerDataChanged(tempData)
            const schema = LoadSchema(tempData, player, getSchemaOptions(false))
            const modelData = SavantModel(schema, tempData)
            const tempStats = runCalculations(modelData)
            playerStatsChanged(tempStats)
        }
    })

    // eslint-disable-next-line no-shadow
    function getUniqGames(pitches, years) {
        const numberYears = years.map((d) => Number(d))
        return uniqBy(pitches, (d) => d.game_pk)
            .filter(
                (d) =>
                    d.game_pk !== null && numberYears.includes(Number(d.year))
            )
            .map((d) => ({
                name: `${d.away_team} vs. ${d.home_team} - ${moment(
                    d.game_date
                ).format('YYYY-MM-DD')}`,
                value: d.game_pk,
            }))
    }

    function setUniqValues(tempData) {
        const tempPitchTypes = uniqBy(tempData, (d) => d.pitch_type)
            .filter((d) => d.pitch_type !== null && d.pitch_type !== '')
            .map((d) => ({
                name: d.pitch_name,
                value: d.pitch_type,
            }))

        setUniqPitches(tempPitchTypes)
        /*        setUniqValues(
            uniqBy(tempData, (d) => {
                return d.pitch_type;
            })
                .filter((d) => {
                    return d.pitch_type !== null && d.pitch_type !== "";
                })
                .map((d) => {
                    return {
                        name: d.pitch_name,
                        value: d.pitch_type,
                    };
                })
        ); */

        const tempYears = sortBy(
            uniqBy(tempData, (d) => d.game_year).map((d) => Number(d.game_year))
        ).reverse()

        setUniqYears(tempYears)
        if (!queryString.years) {
            setYears([tempYears[0]])
        }

        let oPT = otherPlayerType
        if (playerInfo && oPT === playerInfo.playerType) {
            oPT = playerInfo.playerType === 'pitcher' ? 'batter' : 'pitcher'
        }

        const tempPlayers = sortBy(
            uniqBy(tempData, (d) => d[oPT])
                .filter((d) => d[oPT] !== null)
                .map((d) => ({
                    name: d[`${oPT}_name`],
                    value: d[oPT],
                })),
            (d) => d.name
        )

        setUniqPlayers(tempPlayers)

        setUniqGames(getUniqGames(tempData, years))
    }

    useEffect(() => {
        function handleResize() {
            setPageWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
    })

    useEffect(() => {
        if (updateId > 0) {
            populateUrl()
        }
    }, [updateId])

    const handleChange = (event) => {
        setInputValue(event.target.value)
    }

    const tabChanged = (event, newValue) => {
        setTabSelection(newValue)
        setUpdateId(updateId + 1)
    }

    useEffect(() => {
        if (playerInfo) {
            loadPlayerData() // This is be executed when `loading` state changes
        }
    }, [playerInfo])

    function getPlayerType(isPitcher) {
        const findPlayerType = isPitcher ? 'pitcher' : 'batter'

        if (findPlayerType === 'pitcher') {
            setOtherPlayerType('batter')
        } else {
            setOtherPlayerType('pitcher')
        }
        setUpdateId(updateId + 1)
        return findPlayerType
    }

    function loadPlayerData() {
        let loadYear = currentYear
        let hasFoundYear = false
        const incrementalYears = []
        let queryData = []

        // Function to laod data back to 2015
        function loadData(callback) {
            const pType = playerInfo.playerType
            if (pType === 'pitcher') {
                setOtherPlayerType('batter')
            } else {
                setOtherPlayerType('pitcher')
            }

            setPlayer({
                playerType: pType,
                playerId: playerInfo.playerId,
                playerName: playerInfo.name,
            })

            csv(
                `/feed?evp=true&csv=true&hfPT=&hfAB=&hfBBT=&hfPR=&hfZ=&stadium=&hfBBL=&hfNewZones=&hfGT=R|PO%7C&hfC=&hfSea=${loadYear}%7C&hfSit=&player_type=${pType}&hfOuts=&opponent=&pitcher_throws=&batter_stands=&hfSA=&game_date_gt=&game_date_lt=&hfInfield=&team=&position=&hfOutfield=&hfRO=&home_road=&${pType}s_lookup[]=${
                    playerInfo.playerId
                }&hfFlag=&hfPull=&metric_1=&hfInn=&min_pitches=0&min_results=0&group_by=name&sort_col=pitches&player_event_sort=h_launch_speed&sort_order=desc&min_pas=0&type=details&player_id=${
                    playerInfo.playerId
                }&minors=${isMinors ? 'true' : ''}`
            ).then((responseData) => {
                if (responseData.length > 0) {
                    if (!hasFoundYear && !queryString.years) {
                        setYears([loadYear])
                        setUpdateId(updateId + 1)
                        hasFoundYear = true
                    }
                    incrementalYears.push(loadYear)
                    setUniqYears(incrementalYears)

                    queryData = queryData.concat(responseData)
                    queryData = sortBy(queryData, (d) => {
                        const gd = d.game_date.split('-').join('')
                        const sortNumber = Number(
                            `${gd}${String(d.inning).padStart(2, '0')}${String(
                                d.at_bat_number
                            ).padStart(3, '0')}${String(
                                d.pitch_number
                            ).padStart(3, '0')}`
                        )
                        return sortNumber
                    })
                    staticPlayerDataChanged(queryData)
                    playerDataChanged(queryData)
                    // const tempStats = runCalculations(queryData);
                    const schema = LoadSchema(
                        queryData,
                        player,
                        getSchemaOptions(false)
                    )
                    const modelData = SavantModel(schema, queryData)

                    const tempStats = runCalculations(modelData)
                    playerStatsChanged(tempStats)
                    setIsDataLoading(false)
                    setIsYearlyDataLoading(true)
                }
                loadYear -= 1
                callback(null)
            })
        }
        setIsDataLoading(true)
        checkForHittingAndPitchingStats(playerInfo)

        const funcs = []
        for (let i = currentYear; i > yearMin; i--) {
            funcs.push(loadData)
        }

        async.waterfall(funcs, (err) => {
            setIsYearlyDataLoading(false)
            if (err) {
                setPlayerInfo([])
            } else {
                setUniqValues(queryData)
            }
        })
    }

    // if queryString playerId is set autoload data
    if (queryString.playerId && !pageLoad) {
        setPlayerInfo({
            playerId: queryString.playerId,
            name: queryString.name,
            playerType: queryString.playerType,
        })
        setUpdateId(updateId + 1)
        setPageLoad(true)
    }

    // eslint-disable-next-line no-shadow
    function checkForHittingAndPitchingStats(playerInfo) {
        /// Does the player have both hitting & pitching stats
        fetch(`/illustrator/stats?playerId=${playerInfo.playerId}`)
            .then((response) => {
                if (!response.ok) {
                    return { error: 'No data' }
                }
                return response.json()
            })
            .then((data) => {
                if (data && data.stats) {
                    if (
                        find(
                            data.stats,
                            (d) => d.group.displayName === 'pitching'
                        ) &&
                        find(
                            data.stats,
                            (d) => d.group.displayName === 'hitting'
                        )
                    ) {
                        setTogglePlayerStats(true)
                    }
                }
            })
    }

    const queryUrl = useMemo(
        () =>
            throttle((request, callback) => {
                if (request && request.input) {
                    if (request.input.length >= 3) {
                        fetch(
                            `/player/search-statcast?search=${
                                request.input
                            }&minors=${isMinors ? 'true' : ''}`
                        )
                            .then((response) => {
                                if (!response.ok) {
                                    return { error: 'No data' }
                                }
                                return response.json()
                            })
                            .then((data) => {
                                callback(data)
                            })
                    }
                }
            }, 200),
        []
    )

    useEffect(() => {
        let active = true

        if (inputValue === '') {
            setOptions(trendingPlayers)
            return undefined
        }

        queryUrl({ input: inputValue }, (results) => {
            if (active) {
                setOptions(results || [])
            }
        })

        return () => {
            active = false
        }
    }, [inputValue, queryUrl])

    function getSchemaOptions(embed) {
        return {
            selectedChart: chartType,
            yearText: years.join(','),
            subTitle,
            shape,
            embed,
            chartName,
            venueId,
            pageWidth,
            perspective,
            teamLogoId: isMinors ? 'milb' : 'primary',
        }
    }

    const showPerspectiveSelect =
        chartType.includes('zoneChart') ||
        chartType.includes('pitchChart') ||
        chartType.includes('hexBinChart') ||
        chartType === 'pitchContourChart' ||
        chartType === 'pitchPie'

    return (
        <StylesProvider generateClassName={generateClassName}>
            <div className="form">
                <div className="evp-form">
                    {playerData ? (
                        <img
                            src="/sections/evp/images/logo.png"
                            className="illustrator-logo"
                            alt="Illustrator Logo"
                        />
                    ) : null}
                    {playerData && isMinors ? (
                        <div style={{ marginBottom: '1rem' }}>
                            <img
                                src="https://www.mlbstatic.com/team-logos/league-on-light/milb-alt.svg"
                                width="50"
                                alt="Minor League Logo"
                            />{' '}
                            Minor Leagues
                        </div>
                    ) : null}
                    <div style={{ marginBottom: '1rem' }}>
                        <Autocomplete
                            id="search-complete"
                            defaultValue={queryString.name || null}
                            style={{ width: '100%' }}
                            classes={{
                                root: autoCompleteStyles.root, // class name, e.g. `classes-nesting-root-x`
                                inputRoot: autoCompleteStyles.inputRoot,
                                input: autoCompleteStyles.input,
                            }}
                            onChange={(event, value) => {
                                playerDataChanged(null)
                                if (value) {
                                    if (value.player_id) {
                                        // Remove trending players after selection
                                        setOptions([])
                                        setPlayerInfo({
                                            playerId: value.player_id,
                                            name: value.name_display_first_last,
                                            playerType: getPlayerType(
                                                value.is_pitcher
                                            ),
                                        })
                                        setUpdateId(updateId + 1)
                                    }
                                } else {
                                    const element =
                                        document.getElementById('evp')
                                    element.parentNode.removeChild(element)
                                    // TODO: Remove this hack
                                    const url = isMinors
                                        ? '/illustrator-minors'
                                        : '/illustrator'
                                    window.location = url
                                }
                            }}
                            freeSolo
                            filterOptions={(x) => x}
                            options={options}
                            autoComplete
                            getOptionLabel={(option) => {
                                if (typeof option !== 'string') {
                                    if (!option.id) {
                                        return ''
                                    }
                                    return option.name_display_first_last
                                }
                                return option
                            }}
                            autoHighlight
                            clearOnEscape
                            includeInputInList
                            blurOnSelect="touch"
                            renderInput={(params) => {
                                // eslint-disable-next-line no-param-reassign
                                params.InputProps.classes = {
                                    root: autoCompleteStyles.cssOutlinedInput,
                                    focused: autoCompleteStyles.cssFocused,
                                    notchedOutline:
                                        autoCompleteStyles.notchedOutline,
                                }

                                return (
                                    <TextField
                                        {...params}
                                        InputLabelProps={{
                                            classes: {
                                                root: autoCompleteStyles.label,
                                                focused:
                                                    autoCompleteStyles.focus,
                                                shrink: autoCompleteStyles.focus,
                                            },
                                        }}
                                        label="Enter Player Name"
                                        variant="outlined"
                                        fullWidth
                                        onChange={handleChange}
                                    />
                                )
                            }}
                            renderOption={(option) => {
                                if (!option.player_id) {
                                    return (
                                        <div className="trending-player-text">
                                            Trending Players
                                        </div>
                                    )
                                }
                                const imageUrl = isMinors
                                    ? `https://midfield.mlbstatic.com/v1/people/${option.player_id}/milb/60?circle=true`
                                    : `https://content.mlb.com/images/headshots/current/60x60/${option.player_id}.png`
                                return (
                                    <Grid container alignItems="center">
                                        <Grid item>
                                            <img
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                }}
                                                src={imageUrl}
                                                onError={(e) => {
                                                    // eslint-disable-next-line no-param-reassign
                                                    e.target.onerror = null
                                                    // eslint-disable-next-line no-param-reassign
                                                    e.target.src =
                                                        'https://content.mlb.com/images/headshots/current/60x60/generic.png'
                                                }}
                                                alt={`${option.name_display_first_last} Headshot`}
                                            />
                                            &nbsp;
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                <b>
                                                    {
                                                        option.name_display_first_last
                                                    }
                                                </b>
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {' '}
                                                {' - '}
                                                {option.is_pitcher
                                                    ? ' Pitcher'
                                                    : ' Batter'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )
                            }}
                        />
                        {!playerData && !isDataLoading ? (
                            <svg width="320" height="150">
                                <defs>
                                    <marker
                                        id="arrow"
                                        viewBox="0,0,5,5"
                                        refX="2.5"
                                        refY="2.5"
                                        markerWidth="5"
                                        markerHeight="5"
                                        orient="auto-start-reverse"
                                    >
                                        <path
                                            d="M0,0L0,5L5,2.5"
                                            stroke="tomato"
                                            fill="tomato"
                                        />
                                    </marker>
                                </defs>
                                <path
                                    id="pointer"
                                    d="M100,10L105,28.333333333333332C110,46.666666666666664,120,83.33333333333333,156.66666666666666,101.66666666666667C193.33333333333334,120,256.6666666666667,120,288.3333333333333,120L320,120"
                                    fill="none"
                                    stroke="#ef4c29"
                                    strokeWidth="2"
                                    markerStart="url(#arrow)"
                                />
                                <text
                                    dy="-5"
                                    fill="#3a9098"
                                    className="start-here-pointer-text"
                                >
                                    <textPath
                                        xlinkHref="#pointer"
                                        startOffset="50%"
                                        y="10"
                                        style={{ textAnchor: 'middle' }}
                                    >
                                        Start Here
                                    </textPath>
                                </text>
                            </svg>
                        ) : null}
                        {playerData ? (
                            // eslint-disable-next-line react/button-has-type
                            <button
                                className="mobile-toggle btn btn-default"
                                onClick={() => {
                                    setTweakVisual(!tweakVisual)
                                }}
                            >
                                {tweakVisual ? `Close Edits` : `Edit Visual`}
                            </button>
                        ) : null}
                        <div className="controls-container">
                            <div
                                className="controls"
                                style={{
                                    display:
                                        tweakVisual || pageWidth >= 1080
                                            ? 'block'
                                            : 'none',
                                }}
                            >
                                <div
                                    style={{
                                        paddingTop: '1rem',
                                        paddingBottom: '1rem',
                                    }}
                                >
                                    {playerData ? (
                                        <>
                                            {togglePlayerStats ? (
                                                // eslint-disable-next-line react/button-has-type
                                                <button
                                                    className="btn btn-default"
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    onClick={() => {
                                                        const playerType =
                                                            playerInfo.playerType ===
                                                            'batter'
                                                                ? 'pitcher'
                                                                : 'batter'
                                                        const url =
                                                            populateUrl(
                                                                playerType
                                                            )
                                                        window.location = `/illustrator${url}`
                                                    }}
                                                >
                                                    Switch to{' '}
                                                    {playerInfo.playerType ===
                                                    'batter'
                                                        ? 'Pitching'
                                                        : 'Batting'}{' '}
                                                    Visuals
                                                </button>
                                            ) : null}
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="dropdown">
                                                    <span
                                                        id="lblChartType"
                                                        className="ddl-label"
                                                    >
                                                        Chart: {chartName}
                                                    </span>
                                                    <div className="dropdown-arrow">
                                                        ▾
                                                    </div>
                                                    <select
                                                        value={chartType}
                                                        onChange={(event) => {
                                                            setChartType(
                                                                event.target
                                                                    .value
                                                            )
                                                            const index =
                                                                event.target
                                                                    .selectedIndex
                                                            setChartName(
                                                                event.target[
                                                                    index
                                                                ].text
                                                            )
                                                            setUpdateId(
                                                                updateId + 1
                                                            )
                                                        }}
                                                    >
                                                        <optgroup label="Zone Chart">
                                                            <option value="zoneChart-totalPitches">
                                                                Zone - Total
                                                                Pitches
                                                            </option>
                                                            <option value="zoneChart-percent">
                                                                Zone - Pitch
                                                                Percent
                                                            </option>
                                                            <option value="zoneChart-ba">
                                                                Zone - Batting
                                                                Avg
                                                            </option>
                                                            <option value="zoneChart-woba">
                                                                Zone - wOBA
                                                            </option>
                                                            <option value="zoneChart-avgExitVelocity">
                                                                Zone - Exit
                                                                Velocity
                                                            </option>
                                                            <option value="zoneChart-avgLaunchAngle">
                                                                Zone - Launch
                                                                Angle
                                                            </option>
                                                            <option value="zoneChart-batSpeedCompetitive">
                                                                Zone - Bat Speed
                                                            </option>
                                                            <option value="zoneChart-swingLengthCompetitive">
                                                                Zone - Swing
                                                                Length
                                                            </option>
                                                            <option value="zoneChart-kPercent">
                                                                Zone - K Percent
                                                            </option>
                                                            <option value="zoneChart-runExp">
                                                                Zone - Batter
                                                                Run Value
                                                            </option>
                                                            <option value="zoneChart-pitcherRunExp">
                                                                Zone - Pitcher
                                                                Run Value
                                                            </option>
                                                        </optgroup>
                                                        {playerData &&
                                                        playerData.length <
                                                            4000 ? (
                                                            <optgroup label="Pitch Charts">
                                                                <option value="pitchChart-pitchName">
                                                                    Pitch Types
                                                                </option>
                                                                <option value="pitchChart-pitchResult">
                                                                    Pitch
                                                                    Description
                                                                </option>
                                                                <option value="pitchChart-paResult">
                                                                    Pitch Result
                                                                </option>
                                                                <option value="pitchChart-battedBallType">
                                                                    Batted Ball
                                                                    Type
                                                                </option>
                                                            </optgroup>
                                                        ) : null}
                                                        <option value="pitchContourChart">
                                                            Pitch Heatmap
                                                        </option>
                                                        <optgroup label="Pitch Hexbin Charts">
                                                            <option value="hexBinChart-totalPitches">
                                                                Total Pitches
                                                            </option>
                                                            <option value="hexBinChart-ba">
                                                                Batting Avg
                                                            </option>
                                                            <option value="hexBinChart-woba">
                                                                wOBA
                                                            </option>
                                                            <option value="hexBinChart-avgExitVelocity">
                                                                Exit Velocity
                                                            </option>
                                                            <option value="hexBinChart-avgLaunchAngle">
                                                                Launch Angle
                                                            </option>
                                                            <option value="hexBinChart-kPercent">
                                                                K Percent
                                                            </option>
                                                        </optgroup>

                                                        <option value="pitchPie">
                                                            Pitch Pie Chart
                                                        </option>
                                                        <optgroup label="Pitch Count Breakdowns">
                                                            <option value="network-pie">
                                                                Pie Charts
                                                            </option>
                                                            <option value="network-circlePack">
                                                                Circles
                                                            </option>
                                                        </optgroup>
                                                        {playerData &&
                                                        playerData.length <
                                                            4000 ? (
                                                            <>
                                                                <option value="release">
                                                                    Release
                                                                    Point
                                                                </option>
                                                                <option value="movement">
                                                                    Pitch
                                                                    Movement
                                                                </option>

                                                                <optgroup label="Line Chart">
                                                                    <option value="lineGraphChart-pitchVelocity">
                                                                        Pitch
                                                                        Velocity
                                                                    </option>
                                                                    <option value="lineGraphChart-spinRate">
                                                                        Spin
                                                                        Rate
                                                                    </option>
                                                                </optgroup>
                                                            </>
                                                        ) : null}
                                                        <option value="radial">
                                                            Radial
                                                        </option>
                                                        <option value="sprayChart">
                                                            Spray Chart
                                                        </option>
                                                        <option value="sprayContourChart">
                                                            Spray Heatmap
                                                        </option>
                                                        <optgroup label="Spray Hexbin Charts">
                                                            <option value="sprayHexBinChart-totalPitches">
                                                                Total Batted
                                                                Balls
                                                            </option>
                                                            <option value="sprayHexBinChart-ba">
                                                                Batting Avg
                                                            </option>
                                                            <option value="sprayHexBinChart-woba">
                                                                wOBA
                                                            </option>
                                                            <option value="sprayHexBinChart-avgExitVelocity">
                                                                Exit Velocity
                                                            </option>
                                                            <option value="sprayHexBinChart-avgLaunchAngle">
                                                                Launch Angle
                                                            </option>
                                                        </optgroup>

                                                        <optgroup label="3d Spray Chart">
                                                            <option value="3d-birdsEye">
                                                                3D Spray - Birds
                                                                Eye
                                                            </option>
                                                            <option value="3d-cf">
                                                                3D Spray - CF
                                                                View
                                                            </option>
                                                            <option value="3d-default">
                                                                3D Spray - High
                                                                Home
                                                            </option>
                                                            <option value="3d-homeLow">
                                                                3D Spray - Low
                                                                Home
                                                            </option>
                                                        </optgroup>
                                                    </select>
                                                </div>
                                            </div>

                                            {uniqYears ? (
                                                <div className="form-option">
                                                    <MultiPick
                                                        name="Year"
                                                        columns={uniqYears}
                                                        currentSelection={years}
                                                        zIndex={1010}
                                                        showValues
                                                        updatedSelection={(
                                                            values
                                                        ) => {
                                                            setYears(values)
                                                            setUpdateId(
                                                                updateId + 1
                                                            )
                                                            setUniqGames(
                                                                getUniqGames(
                                                                    staticPlayerData,
                                                                    values
                                                                )
                                                            )
                                                        }}
                                                    />
                                                    {isYearlyDataLoading ? (
                                                        <div className="loading-data">
                                                            <img
                                                                src="/site-core/images/spinner.gif"
                                                                alt="loading"
                                                            />{' '}
                                                            Previous Years Data
                                                            Still Loading in the
                                                            Background
                                                        </div>
                                                    ) : null}
                                                </div>
                                            ) : null}
                                            <div className="form-option">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Subtitle.."
                                                    className="text-box"
                                                    value={subTitle}
                                                    onChange={(event) => {
                                                        setSubTitle(
                                                            event.target.value
                                                        )
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <div className="dropdown">
                                                    <span
                                                        id="lblChartSize"
                                                        className="ddl-label"
                                                        style={{
                                                            fontSize: '.8rem',
                                                        }}
                                                    >
                                                        Size: {shapeName}
                                                    </span>
                                                    <div className="dropdown-arrow">
                                                        ▾
                                                    </div>
                                                    <select
                                                        value={shape}
                                                        onChange={(event) => {
                                                            setShape(
                                                                event.target
                                                                    .value
                                                            )
                                                            const index =
                                                                event.target
                                                                    .selectedIndex
                                                            setShapeName(
                                                                event.target[
                                                                    index
                                                                ].text
                                                            )
                                                            setUpdateId(
                                                                updateId + 1
                                                            )
                                                        }}
                                                    >
                                                        <option value="square">
                                                            Square (Instagram)
                                                        </option>
                                                        <option value="twitter">
                                                            Rectangle (Twitter)
                                                        </option>
                                                        <option value="snap">
                                                            Portrait
                                                            (Snapchat/Instastory)
                                                        </option>
                                                    </select>
                                                </div>
                                                {chartType.indexOf('spray') >
                                                    -1 ||
                                                chartType.indexOf('3d') > -1 ? (
                                                    <div className="form-option">
                                                        <div className="dropdown">
                                                            <span
                                                                id="lblVenue"
                                                                className="ddl-label"
                                                                style={{
                                                                    fontSize:
                                                                        '.9rem',
                                                                    textOverflow:
                                                                        'ellipsis',
                                                                    overflow:
                                                                        'hidden',
                                                                    whiteSpace:
                                                                        'nowrap',
                                                                }}
                                                            >
                                                                Venue:{' '}
                                                                {venueName}
                                                            </span>
                                                            <div className="dropdown-arrow">
                                                                ▾
                                                            </div>
                                                            <select
                                                                value={venueId}
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    setVenueId(
                                                                        event
                                                                            .target
                                                                            .value
                                                                    )
                                                                    const index =
                                                                        event
                                                                            .target
                                                                            .selectedIndex
                                                                    setVenueName(
                                                                        event
                                                                            .target[
                                                                            index
                                                                        ].text
                                                                    )
                                                                    setUpdateId(
                                                                        updateId +
                                                                            1
                                                                    )
                                                                }}
                                                            >
                                                                {venues.venues.map(
                                                                    (venue) => (
                                                                        <option
                                                                            key={
                                                                                venue.value
                                                                            }
                                                                            value={
                                                                                venue.value
                                                                            }
                                                                        >
                                                                            {
                                                                                venue.name
                                                                            }
                                                                        </option>
                                                                    )
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                            {showPerspectiveSelect && (
                                                <div className="form-option">
                                                    <div className="dropdown">
                                                        <span
                                                            id="lblChartPerspective"
                                                            className="ddl-label"
                                                            style={{
                                                                fontSize:
                                                                    '.8rem',
                                                            }}
                                                        >
                                                            View: {perspective}{' '}
                                                            Perspective
                                                        </span>
                                                        <div className="dropdown-arrow">
                                                            ▾
                                                        </div>
                                                        <select
                                                            value={perspective}
                                                            onChange={(e) => {
                                                                setPerspective(
                                                                    e.target
                                                                        .value
                                                                )
                                                                setUpdateId(
                                                                    updateId + 1
                                                                )
                                                            }}
                                                        >
                                                            <option value="pitcher">
                                                                Pitcher
                                                                Perspective
                                                            </option>
                                                            <option value="catcher">
                                                                Catcher
                                                                Perspective
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="form-option">
                                                <button
                                                    style={{
                                                        width: '32%',
                                                    }}
                                                    className="btn btn-default btn-search-green"
                                                    onClick={() => {
                                                        setSaveImageText(
                                                            'Saving Image...'
                                                        )
                                                        setIsSavingImage(true)
                                                        SaveImage(
                                                            {
                                                                data: playerData,
                                                                player,
                                                                options:
                                                                    getSchemaOptions(
                                                                        false
                                                                    ),
                                                            },
                                                            (err) => {
                                                                setIsSavingImage(
                                                                    false
                                                                )
                                                                setSaveImageText(
                                                                    'Save Image'
                                                                )
                                                                if (err) {
                                                                    console.error(
                                                                        err
                                                                    )
                                                                } else {
                                                                    setIsSavingImage(
                                                                        false
                                                                    )
                                                                    setSaveImageText(
                                                                        'Save Image'
                                                                    )
                                                                }
                                                            }
                                                        )
                                                    }}
                                                >
                                                    {saveImageText}
                                                </button>{' '}
                                                <button
                                                    style={{
                                                        width: '32%',
                                                    }}
                                                    className="btn btn-default btn-search-green"
                                                    onClick={() => {
                                                        setIsSavingImage(true)
                                                        setEmbedImageText(
                                                            'Generating Link...'
                                                        )
                                                        SaveImage(
                                                            {
                                                                data: playerData,
                                                                player,
                                                                options:
                                                                    getSchemaOptions(
                                                                        true
                                                                    ),
                                                            },
                                                            (err, res) => {
                                                                setIsSavingImage(
                                                                    false
                                                                )
                                                                setSaveImageText(
                                                                    'Save Image'
                                                                )
                                                                if (
                                                                    res &&
                                                                    res.link
                                                                ) {
                                                                    setEmbedLink(
                                                                        `<iframe src="https://baseballsavant.mlb.com/illustrator/static?guid=${res.link}&scale=true"></iframe>`
                                                                    )
                                                                    setModalOpen(
                                                                        true
                                                                    )
                                                                } else if (
                                                                    err
                                                                ) {
                                                                    console.error(
                                                                        res.err
                                                                    )
                                                                }
                                                                setEmbedImageText(
                                                                    'Embed Image'
                                                                )
                                                            }
                                                        )
                                                    }}
                                                >
                                                    {embedImageText}
                                                </button>{' '}
                                                <button
                                                    className="btn btn-default"
                                                    style={{
                                                        backgroundColor:
                                                            '#f5f5f5',
                                                        color: '#000',
                                                        width: '31%',
                                                    }}
                                                    onClick={() => {
                                                        resetStateFormValues()
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                >
                                                    Clear Form
                                                </button>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                                {isDataLoading ? (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            paddingTop: '1rem',
                                        }}
                                    >
                                        <h6>
                                            Visualizing Data... Please Wait.
                                        </h6>
                                        <br />
                                        <br />
                                        <CircularProgress />
                                    </div>
                                ) : null}
                                {playerData ? (
                                    <>
                                        <AppBar
                                            position="static"
                                            color="default"
                                        >
                                            <Tabs
                                                value={tabSelection}
                                                onChange={tabChanged}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                scrollButtons="off"
                                                aria-label="Selection Tabs"
                                            >
                                                <Tab
                                                    disabled={!playerData}
                                                    style={{ minWidth: '70px' }}
                                                    classes={{
                                                        root: classes.tabRoot,
                                                    }}
                                                    label="Play"
                                                    {...a11yProps(0)}
                                                />
                                                <Tab
                                                    disabled={!playerData}
                                                    style={{ minWidth: '70px' }}
                                                    classes={{
                                                        root: classes.tabRoot,
                                                    }}
                                                    label="Game"
                                                    {...a11yProps(1)}
                                                />
                                                <Tab
                                                    disabled={!playerData}
                                                    style={{ minWidth: '70px' }}
                                                    classes={{
                                                        root: classes.tabRoot,
                                                    }}
                                                    label="Teams"
                                                    {...a11yProps(2)}
                                                />
                                            </Tabs>
                                        </AppBar>
                                        <TabPanel
                                            value={tabSelection}
                                            index={0}
                                        >
                                            <div className="form-option">
                                                <div className="dropdown">
                                                    <span
                                                        id="lblPitcherThrows"
                                                        className="ddl-label"
                                                    >
                                                        Pitcher Throws:{' '}
                                                        {pitcherThrows || 'All'}
                                                    </span>
                                                    <div className="dropdown-arrow">
                                                        ▾
                                                    </div>
                                                    <select
                                                        value={pitcherThrows}
                                                        onChange={(event) => {
                                                            setPitcherThrows(
                                                                event.target
                                                                    .value
                                                            )
                                                            setUpdateId(
                                                                updateId + 1
                                                            )
                                                        }}
                                                    >
                                                        <option value="">
                                                            All
                                                        </option>
                                                        <option value="R">
                                                            Right
                                                        </option>
                                                        <option value="L">
                                                            Left
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-option">
                                                <div className="dropdown">
                                                    <span
                                                        id="lblBatterStands"
                                                        className="ddl-label"
                                                    >
                                                        Batter Stands:{' '}
                                                        {batterStands || 'All'}
                                                    </span>
                                                    <div className="dropdown-arrow">
                                                        ▾
                                                    </div>
                                                    <select
                                                        value={batterStands}
                                                        onChange={(event) => {
                                                            setBatterStands(
                                                                event.target
                                                                    .value
                                                            )
                                                            setUpdateId(
                                                                updateId + 1
                                                            )
                                                        }}
                                                    >
                                                        <option value="">
                                                            All
                                                        </option>
                                                        <option value="R">
                                                            Right
                                                        </option>
                                                        <option value="L">
                                                            Left
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Season Type"
                                                    columns={events.seasonTypes}
                                                    currentSelection={
                                                        seasonType
                                                    }
                                                    zIndex={1008}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setSeasonType(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Plate Appearance"
                                                    columns={
                                                        events.plateAppearanceResults
                                                    }
                                                    currentSelection={
                                                        plateAppearanceResults
                                                    }
                                                    zIndex={1009}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setPlateAppearanceResults(
                                                            values
                                                        )
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>

                                            <div className="form-option">
                                                <MultiPick
                                                    name="Pitch Result"
                                                    columns={events.pitchResult}
                                                    currentSelection={
                                                        pitchResults
                                                    }
                                                    zIndex={1010}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setPitchResults(values)
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Pitch Type"
                                                    columns={uniqPitches}
                                                    currentSelection={
                                                        pitchTypes
                                                    }
                                                    zIndex={1008}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setPitchTypes(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Facing Player"
                                                    columns={uniqPlayers}
                                                    currentSelection={
                                                        facingPlayer
                                                    }
                                                    zIndex={1007}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setFacingPlayer(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <Typography
                                                    id="discrete-slider-restrict"
                                                    gutterBottom
                                                >
                                                    Pitch Velocity &gt;=
                                                </Typography>
                                                <Slider
                                                    defaultValue={0}
                                                    getAriaValueText={
                                                        sliderValueText
                                                    }
                                                    aria-labelledby="discrete-slider-restrict"
                                                    step={1}
                                                    value={pitchVelocityGT}
                                                    valueLabelDisplay="auto"
                                                    min={0}
                                                    max={105}
                                                    marks
                                                    onChange={(
                                                        event,
                                                        value
                                                    ) => {
                                                        setPitchVelocityGT(
                                                            value
                                                        )
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <Typography
                                                    id="discrete-slider-restrict"
                                                    gutterBottom
                                                >
                                                    Pitch Velocity &lt;=
                                                </Typography>
                                                <Slider
                                                    defaultValue={105}
                                                    getAriaValueText={
                                                        sliderValueText
                                                    }
                                                    aria-labelledby="discrete-slider-restrict"
                                                    step={1}
                                                    value={pitchVelocityLT}
                                                    valueLabelDisplay="auto"
                                                    min={0}
                                                    max={105}
                                                    marks
                                                    onChange={(
                                                        event,
                                                        value
                                                    ) => {
                                                        setPitchVelocityLT(
                                                            value
                                                        )
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>

                                            <div className="form-option">
                                                <Typography
                                                    id="discrete-slider-restrict"
                                                    gutterBottom
                                                >
                                                    Exit Velocity &gt;=
                                                </Typography>
                                                <Slider
                                                    defaultValue={0}
                                                    getAriaValueText={
                                                        sliderValueText
                                                    }
                                                    aria-labelledby="discrete-slider-restrict"
                                                    value={exitVelocityGT}
                                                    step={1}
                                                    valueLabelDisplay="auto"
                                                    min={0}
                                                    max={125}
                                                    marks
                                                    onChange={(
                                                        event,
                                                        value
                                                    ) => {
                                                        setExitVelocityGT(value)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <Typography
                                                    id="discrete-slider-restrict"
                                                    gutterBottom
                                                >
                                                    Exit Velocity &lt;=
                                                </Typography>
                                                <Slider
                                                    defaultValue={125}
                                                    getAriaValueText={
                                                        sliderValueText
                                                    }
                                                    aria-labelledby="discrete-slider-restrict"
                                                    step={1}
                                                    value={exitVelocityLT}
                                                    valueLabelDisplay="auto"
                                                    min={0}
                                                    max={125}
                                                    marks
                                                    onChange={(
                                                        event,
                                                        value
                                                    ) => {
                                                        setExitVelocityLT(value)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <Typography
                                                    id="discrete-slider-restrict"
                                                    gutterBottom
                                                >
                                                    Launch Angle &gt;=
                                                </Typography>
                                                <Slider
                                                    defaultValue={-90}
                                                    getAriaValueText={
                                                        sliderValueText
                                                    }
                                                    aria-labelledby="discrete-slider-restrict"
                                                    step={1}
                                                    value={launchAngleGT}
                                                    valueLabelDisplay="auto"
                                                    min={-90}
                                                    max={90}
                                                    marks
                                                    onChange={(
                                                        event,
                                                        value
                                                    ) => {
                                                        setLaunchAngleGT(value)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <Typography
                                                    id="discrete-slider-restrict"
                                                    gutterBottom
                                                >
                                                    Launch Angle &lt;=
                                                </Typography>
                                                <Slider
                                                    defaultValue={90}
                                                    getAriaValueText={
                                                        sliderValueText
                                                    }
                                                    aria-labelledby="discrete-slider-restrict"
                                                    step={1}
                                                    value={launchAngleLT}
                                                    valueLabelDisplay="auto"
                                                    min={-90}
                                                    max={90}
                                                    marks
                                                    onChange={(
                                                        event,
                                                        value
                                                    ) => {
                                                        setLaunchAngleLT(value)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                        </TabPanel>
                                        <TabPanel
                                            value={tabSelection}
                                            index={1}
                                        >
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Balls"
                                                    columns={[
                                                        '0',
                                                        '1',
                                                        '2',
                                                        '3',
                                                    ]}
                                                    currentSelection={balls}
                                                    zIndex={1011}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setBalls(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Strikes"
                                                    columns={['0', '1', '2']}
                                                    currentSelection={strikes}
                                                    zIndex={1010}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setStrikes(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Outs"
                                                    columns={['0', '1', '2']}
                                                    currentSelection={outs}
                                                    zIndex={1009}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setOuts(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Batted Ball Type"
                                                    columns={[
                                                        {
                                                            value: 'line_drive',
                                                            name: 'Line Drive',
                                                        },
                                                        {
                                                            value: 'fly_ball',
                                                            name: 'Flyball',
                                                        },
                                                        {
                                                            value: 'ground_ball',
                                                            name: 'Groundball',
                                                        },
                                                        {
                                                            value: 'popup',
                                                            name: 'Popup',
                                                        },
                                                    ]}
                                                    currentSelection={
                                                        battedBallType
                                                    }
                                                    zIndex={1007}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setBattedBallType(
                                                            values
                                                        )
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Game"
                                                    columns={uniqGames}
                                                    currentSelection={
                                                        selectedGames
                                                    }
                                                    zIndex={1006}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setSelectedGames(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <MuiPickersUtilsProvider
                                                utils={DateFnsUtils}
                                            >
                                                <div className="form-option">
                                                    <KeyboardDatePicker
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        disableToolbar
                                                        variant="inline"
                                                        format="yyyy-MM-dd"
                                                        margin="normal"
                                                        id="date-picker-inline"
                                                        label="Game Date >="
                                                        value={gameDateGT}
                                                        onChange={(
                                                            _dateObj,
                                                            dateStr
                                                        ) => {
                                                            setGameDateGT(
                                                                dateStr
                                                            )
                                                        }}
                                                        KeyboardButtonProps={{
                                                            'aria-label':
                                                                'change date',
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-option">
                                                    <KeyboardDatePicker
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        disableToolbar
                                                        variant="inline"
                                                        format="yyyy-MM-dd"
                                                        margin="normal"
                                                        id="date-picker-inline"
                                                        label="Game Date <="
                                                        value={gameDateLT}
                                                        onChange={(
                                                            _dateObj,
                                                            dateStr
                                                        ) =>
                                                            setGameDateLT(
                                                                dateStr
                                                            )
                                                        }
                                                        KeyboardButtonProps={{
                                                            'aria-label':
                                                                'change date',
                                                        }}
                                                    />
                                                </div>
                                            </MuiPickersUtilsProvider>
                                        </TabPanel>
                                        <TabPanel
                                            value={tabSelection}
                                            index={2}
                                        >
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Vs. Team"
                                                    columns={
                                                        teamsById.teamsById
                                                    }
                                                    currentSelection={vsTeam}
                                                    zIndex={1010}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setVsTeam(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>

                                            <div className="form-option">
                                                <MultiPick
                                                    name="Home Team"
                                                    columns={
                                                        teamsById.teamsById
                                                    }
                                                    currentSelection={homeTeam}
                                                    zIndex={1010}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setHomeTeam(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="form-option">
                                                <MultiPick
                                                    name="Away Team"
                                                    columns={
                                                        teamsById.teamsById
                                                    }
                                                    currentSelection={awayTeam}
                                                    zIndex={1010}
                                                    updatedSelection={(
                                                        values
                                                    ) => {
                                                        setAwayTeam(values)
                                                        setUpdateId(
                                                            updateId + 1
                                                        )
                                                    }}
                                                />
                                            </div>
                                        </TabPanel>
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="chart-container"
                    style={{ position: 'relative' }}
                >
                    {playerData && !isDataLoading ? (
                        <div style={{ position: 'sticky', top: 0 }}>
                            <App
                                data={playerData}
                                player={player}
                                options={getSchemaOptions(false)}
                            />
                            {playerStats ? (
                                <>
                                    <br />
                                    <br />
                                    <div className="additional-info">
                                        <div className="additional-info-position">
                                            Additional Info
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="stats">
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                Pitches
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.pitches}
                                            </div>
                                        </div>

                                        <div className="stats-box">
                                            <div className="stats-title">
                                                PA
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.pa}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">H</div>
                                            <div className="stats-value">
                                                {playerStats.hits}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                1B
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.single}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                2B
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.double}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                3B
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.triple}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                HR
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.hr}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                AVG
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.ba}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                SO
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.so}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                wOBA
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.woba}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                K%
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.kPercent}
                                            </div>
                                        </div>

                                        <div className="stats-box">
                                            <div className="stats-title">
                                                EV
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.avgExitVelocity}
                                            </div>
                                        </div>
                                        <div className="stats-box">
                                            <div className="stats-title">
                                                LA
                                            </div>
                                            <div className="stats-value">
                                                {playerStats.avgLaunchAngle}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    ) : (
                        <div className="content-text">
                            <img
                                src="/sections/evp/images/logo.png"
                                className="illustrator-logo"
                                alt="illustrator Logo"
                            />
                            <br />
                            Welcome to <strong>Savant Illustrator</strong>, our
                            new visualization tool designed to illuminate all
                            the inherent nuances and figures that we believe
                            make baseball special. To get started, just...
                            <br />
                            <br />
                            <ol style={{ lineHeight: '2rem' }}>
                                <li>
                                    Enter a player&apos;s name in the search box
                                    or select trending player
                                </li>
                                <li>Choose one of our 30+ Chart Types</li>
                                <li>Customize using our data settings</li>
                                <li>
                                    Save it to share on social media or get an
                                    embed link
                                </li>
                            </ol>
                            <br />
                            Enjoy and let us know what you think at{' '}
                            <a
                                style={{ color: 'tomato' }}
                                href="https://twitter.com/SavantTips"
                                target="_blank"
                                rel="noreferrer"
                            >
                                @SavantTips
                            </a>
                            !
                        </div>
                    )}
                </div>
                {isSavingImage ? (
                    <Dialog
                        open={isSavingImage}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <div
                                    style={{
                                        fontFamily: 'Roboto Condensed',
                                        fontSize: '1.2rem',
                                        textAlign: 'center',
                                    }}
                                >
                                    Saving Image... Please Wait
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <br />
                                    <CircularProgress />
                                </div>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                ) : null}
            </div>
            <Dialog
                open={modalOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Embeddable Link
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Copy the link below to use current visual:
                        <br />
                        <br />
                        {embedLink}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setModalOpen(false)
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </StylesProvider>
    )
}

export default Data
